// import React from "react";
// import CheckTick from "../../assets/greenTick.png";

// const PlanCards = ({ title, description, price, duration, features = [] }) => {
//   return (
//     <div className="planCardsContainer">
//       <>
//         <div className="plan">
//           <div className="plan-name">
//             <div className="circle"></div>
//             <p className="pn">{title}</p>
//           </div>
//           <p className="plan-sub">{description}</p>
//         </div>

//         <div className="cost">
//           <p className="cost-price">{price}</p>
//           <p className="cost-time">{duration}</p>
//         </div>

//         <div className="plan-features">
//           {features.map((feature, idx) => (
//             <div className="eachList" key={idx}>
//               <img src={CheckTick} className="plan-tick" alt="planListTick" />
//               <p className="plan-txt">{feature}</p>
//             </div>
//           ))}
//         </div>
//       </>

//       <div className="planButton">
//         <button className="plan-btn">GET STARTED</button>
//       </div>
//     </div>
//   );
// };

// export default PlanCards;

import React from "react";
import CheckTick from "../../assets/greenTick.png";
import planCard from "../../assets/planCardBg.png";

const PlanCards = ({
  title,
  description,
  price,
  duration,
  features = [],
  isHighlighted,
  onClickFunction,
}) => {
  return (
    <div
      className="planCardsContainer"
      style={{
        color: isHighlighted ? "white" : "black",
        backgroundImage: isHighlighted ? `url(${planCard})` : "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        border: isHighlighted ? "none" : "1px solid #28a382",
      }}
      onClick={onClickFunction}
    >
      <>
        <div className="plan">
          <div className="plan-name">
            <div
              className="circle"
              style={{ backgroundColor: isHighlighted ? "white" : "#28a382" }}
            ></div>
            <p
              className="pn"
              style={{ color: isHighlighted ? "white" : "#28a382" }}
            >
              {title}
            </p>
          </div>
          <p className="plan-sub">{description}</p>
        </div>

        <div className="cost">
          <p
            className="cost-price"
            style={{ color: isHighlighted ? "white" : "#28a382" }}
          >
            {price}
          </p>
          <p
            className="cost-time"
            style={{ color: isHighlighted ? "white" : "#707070" }}
          >
            {duration}
          </p>
        </div>

        <div className="plan-features">
          {features.map((feature, idx) => (
            <div className="eachList" key={idx}>
              <img
                src={CheckTick}
                className="plan-tick"
                alt="planListTick"
                style={{ backgroundColor: isHighlighted ? "white" : "#c5eae0" }}
              />
              <p className="plan-txt">{feature}</p>
            </div>
          ))}
        </div>
      </>

      <div className="planButton">
        <button
          className="plan-btn"
          style={{
            color: isHighlighted ? "#28a382" : "white",
            backgroundColor: isHighlighted ? "white" : "#28a382",
            border: isHighlighted ? "none" : "1px solid #28a382",
          }}
        >
          GET STARTED
        </button>
      </div>
    </div>
  );
};

export default PlanCards;
